import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { DashboardQuery, DashboardMensagem } from "../typings";

export function useDashboardMensagem(params: DashboardQuery) {
  return useQuery<DashboardMensagem, AxiosError>(
    `/v1/dashboards/principal/mensagem-nao-lida-${params.dataFim}-${params.dataInicio}-${params.updatedAt}`,
    async () => {
      const { data } = await http.get<DashboardMensagem>(
        "/v1/dashboards/principal/mensagem-nao-lida",
        {
          params,
        }
      );

      return data;
    }
  );
}
